import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "./AuthForm.css";
import { roles } from "../../constants/Roles";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { GoogleLogin, googleLogout, useGoogleLogin } from "@react-oauth/google";

import { CREATE_USER_MUTATION } from "../../GraphQl/Mutations";
import { ActionCodes } from "../../constants/ActionCodes";
import { LOGIN } from "../../GraphQl/Queries";
import { useDispatch } from "react-redux";
import { setProfile } from "../../redux/actions/user";
import axios from "axios";
import { logout, removeTokens } from "../../functions";
import { Divider, message } from "antd";

const AuthForm = (props) => {
  const dispatch = useDispatch();

  return (
    <section className='authFormWrapper'>
      <section className='authForm col-md-5 '>
        <div className='d-flex align-items-center justify-content-start ' style={{ marginLeft: "10%", paddingTop: "2%", gap: "0 10px" }}>
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            style={{ width: "auto", height: "40px" }}
            alt="logo"
          />
          <span className='authWrapperTitle'>SurveyHub</span>
        </div>
        <Divider style={{ margin: "12px 0" }} />
        {props?.type === "login" ? <Login /> : <Register />}
      </section>
      <section className='authFormImage col-md-7'></section>
    </section>
  );
};
const Login = () => {
  const [loginDetails, setLoginDetails] = useState({
    email: null,
    password: null,
  });
  const [validated, setValidated] = useState(true);
  const [msg, setMessage] = useState("");
  const [getLogin, { error, loading, data }] = useLazyQuery(LOGIN);
  const [messageApi, contextHolder] = message.useMessage();
  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message,
    });
  };

  const err = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const trial = (message) => {
    messageApi.open({
      type: "loading",
      content: message,
    });
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    removeTokens();
  }, []);
  const handleLogin = () => {
    setMessage("");
    if (validated) {
      getLogin({
        variables: {
          loginData: {
            email: loginDetails?.email,
            password: loginDetails?.password,
          },
        },
      });
    } else {
      err("Please check details");
    }
  };

  const [user, setUser] = useState([]);

  // const googleLogin = useGoogleLogin({
  //   onSuccess: (codeResponse) => setUser(codeResponse),
  //   onError: (error) => console.log('Login Failed:', error)
  // });

  const responseMessage = (response) => {
    setUser(response);
  };
  const errorMessage = (error) => {

  };

  useEffect(() => {
    if (
      (loginDetails.email !== null && loginDetails.password !== null) ||
      (loginDetails.email !== "" && loginDetails.password !== "")
    )
      setValidated(true);
    else setValidated(false);
  }, [loginDetails]);

  useEffect(() => {
    if (data) {

      dispatch(setProfile(data?.login));
      localStorage.setItem("shub-sm-token", data?.login?.token);
      localStorage.setItem("shub-userId", data?.login?.user?._id);
      setTimeout(() => {
        navigate("/dashboard/profile");
      }, 1000);
    } else if (error) {
      setMessage("Please check your credentials and try again");
      err("Please check your credentials and try again");
    }
  }, [data, error]);

  useEffect(() => {
    if (user) {

      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.credential}`,
          {
            headers: {
              Authorization: `Bearer ${user.credential}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  // useEffect(() => {
  //   console.log(profile)
  // }, [profile]);

  const logOut = () => {
    googleLogout();
    // setProfile(null);
  };
  return (
    <div className='authFormSection'>
      {contextHolder}
      <div className='authFormTop'>
        <div className='authTitle'> Log In</div>
        <div className='authDesc'>Let's get work started today</div>
      </div>
      <form
        className='authFormControlDiv'
        onSubmit={(e) => {
          e.preventDefault();
          handleLogin();
        }}
      >
        <div className='inputDiv'>
          <div className='input-group'>
            <input
              style={{
                backgroundColor: "#fff"
              }}
              required
              type='email'
              id='email'
              name='email'
              autoComplete='off'
              className='input'
              placeholder='Enter your email'
              onKeyUp={(e) =>
                setLoginDetails({ ...loginDetails, email: e.target.value })
              }
            />
          </div>
          <div className='input-group'>
            <input
              style={{
                backgroundColor: "#fff"
              }}
              required
              type='password'
              id='password'
              name='password'
              autoComplete='off'
              className='input'
              placeholder='Enter your password'
              onKeyUp={(e) =>
                setLoginDetails({ ...loginDetails, password: e.target.value })
              }
            />
          </div>
        </div>
        <button className='btn submitBtn'>
          {loading ? <>Loading</> : <>Log In</>}
        </button>
        <div className=' flex items-center'>
          Click here if you &nbsp;{" "}
          <Link to='/reset-password'>Forgot Password</Link>
        </div>
        {/* <div className="g-signin2" data-onsuccess="onSignIn"></div> */}
        {/* <GoogleLogin
          theme="outline" login_uri={process.env.REACT_APP_URI + "/callback/google"} logo_alignment="left" width="300px"
          cancel_on_tap_outside={true}
          ux_mode="redirect"
          onSuccess={responseMessage} onError={errorMessage}
        /> */}
      </form>

      <div className='messageDiv'>{msg}</div>

      <div className='authFormBottom flex items-center'>
        <span>
          New here ? <Link to='/register'>Create New Account</Link>
        </span>
      </div>
    </div>
  );
};

const Register = () => {
  const [userDetails, setUserDetails] = useState({
    fullName: null,
    email: null,
    password: null,
  });
  const [message, setMessage] = useState("");
  const [trial, setTrial] = useState(false);
  const [createNewUser] = useMutation(CREATE_USER_MUTATION, {
    variables: {
      userDataInput: {
        fullName: userDetails.fullName,
        email: userDetails.email,
        password: userDetails.password,
        // "userType": roles.SURVEYOR
      },
    },
    onCompleted: (data) => {
      setMessage(ActionCodes.S_001);

      setTrial(false);
      clearForm();
    },
    onError: (err) => {
      setMessage(ActionCodes.S_001_0);
      setTrial(false);
      clearForm();
    },
  });
  const navigate = useNavigate();
  const handleRegister = () => {
    let fullName = document.getElementById("fullName").value;
    let email = document.getElementById("email").value;
    let password = document.getElementById("password").value;
    setTrial(true);
    setMessage("");
    if (fullName != "" || email != "" || password != "") {
      setUserDetails({ fullName: fullName, email: email, password: password });
      createNewUser();
    }
    // navigate("/login");
  };

  const clearForm = () => {
    document.getElementById("fullName").value = "";
    document.getElementById("email").value = "";
    document.getElementById("password").value = "";
    setUserDetails({ fullName: null, email: null, password: null });
  };
  useEffect(() => {
    if (message == ActionCodes.S_001)
      setTimeout(() => {
        navigate("/login");
      }, 1000);
  }, [message]);
  return (
    <div className='authFormSection'>
      <div className='authFormTop'>
        <div className='authTitle'>Create new account</div>
        <div className='authDesc'>Let's get a survey form handled today</div>
      </div>
      <form
        className='authFormControlDiv'
        onSubmit={(e) => {
          e.preventDefault();
          handleRegister();
        }}
      >
        <div className='inputDiv'>
          <div className='input-group'>
            <input
              style={{
                backgroundColor: "#fff"
              }}
              required
              type='text'
              name='fullName'
              autoComplete='off'
              className='input'
              placeholder='Enter your full name'
              id='fullName'
              onKeyUp={(e) =>
                setUserDetails({ ...userDetails, fullName: e.target.value })
              }
            />
          </div>
          <div className='input-group'>
            <input
              style={{
                backgroundColor: "#fff"
              }}
              required
              type='email'
              name='email'
              autoComplete='off'
              className='input'
              placeholder='Enter your email'
              id='email'
              onKeyUp={(e) =>
                setUserDetails({ ...userDetails, email: e.target.value })
              }
            />
          </div>
          <div className='input-group'>
            <input
              style={{
                backgroundColor: "#fff"
              }}
              required
              type='password'
              name='password'
              autoComplete='off'
              className='input'
              placeholder='Enter your password'
              id='password'
              onKeyUp={(e) =>
                setUserDetails({ ...userDetails, password: e.target.value })
              }
            />
          </div>
        </div>
        <button className='btn submitBtn' disabled={trial ? true : false}>
          {trial && <>Loading</>}
          {!trial && <>Sign up</>}
        </button>
        <div className='g-signin2' data-onsuccess='onSignIn'></div>
        {/* <div className="btn submitBtn googleBtn flex items-center content-center">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2048px-Google_%22G%22_Logo.svg.png"
            alt=""
          />{" "}
          Sign up with Google
        </div> */}
      </form>
      <div className='messageDiv'>{message}</div>

      <div className='authFormBottom flex items-center'>
        Already have an account ? <Link to='/login'>Log in</Link>
      </div>
    </div>
  );
};
export default AuthForm;
